import styled from 'styled-components';

import createFormSkinStyles from '../controlskin';

export const FormInput = styled.input`
  ${createFormSkinStyles}
`;

export default FormInput;
